var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcondiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16V14H22V3C22 2.20435 21.6839 1.44129 21.1213 0.87868C20.5587 0.31607 19.7956 0 19 0L5 0C4.20435 0 3.44129 0.31607 2.87868 0.87868C2.31607 1.44129 2 2.20435 2 3V14H0V16H11V20H9C8.20435 20 7.44129 20.3161 6.87868 20.8787C6.31607 21.4413 6 22.2044 6 23V24H8V23C8 22.7348 8.10536 22.4804 8.29289 22.2929C8.48043 22.1054 8.73478 22 9 22H15C15.2652 22 15.5196 22.1054 15.7071 22.2929C15.8946 22.4804 16 22.7348 16 23V24H18V23C18 22.2044 17.6839 21.4413 17.1213 20.8787C16.5587 20.3161 15.7956 20 15 20H13V16H24ZM4 3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V14H4V3Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondiscussion);
export default __webpack_public_path__ + "static/media/icon=discussion.58917dc472aa76ad026aa5fa5d23c062.svg";
export { ForwardRef as ReactComponent };